import React, { useState, useContext, useEffect } from "react";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

// IMAGES
import playerShield from "../../images/frame-playershield.png";
import playerShieldFlagBkgnd from "../../images/frame-playershield-flag-bkgnd.jpg";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

export default function PlayerShield({ data, record, winStreak, dataFields }) {
   const forceLineBreak = (text) => {
      if (text) {
         let textArray = text.split(" ");
         let divider = textArray.length === 2 ? "<br />" : " ";
         let response = textArray.join(divider);
         return <div dangerouslySetInnerHTML={{ __html: response }} />;
      }
   };

   return (
      <>
         <>
            <Box
               sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 50,
               }}
            >
               <img src={playerShield} />
            </Box>

            {data && data.CountryFlag && (
               <Box
                  sx={{
                     position: "absolute",
                     top: 620,
                     left: 400,
                     width: 97,
                     height: 60,
                     zIndex: 60,
                     transform: "translateX(-50px)",
                     backgroundSize: "100% 100%",
                     backgroundPosition: "center",
                     backgroundImage: "url(" + playerShieldFlagBkgnd + ")",
                     p: "4px",
                  }}
               >
                  <img src={data.CountryFlag} width='100%' height='100%' />
               </Box>
            )}
            
            {/* Record below flag */}
            {dataFields?.showRecord && record && (
               <Box
                  component={motion.div}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ easing: "easeInOut" }}
                  sx={{
                     position: "absolute",
                     zIndex: 200,
                     top: 710,
                     left: 300,
                     width: 197,
                     textAlign: "center",
                  }}
               >
                  <Typography
                     variant='h1profilevalue'
                     component='div'
                     sx={{ textTransform: "uppercase", fontSize: "3em", color: "#b1b1b1" }}
                  >
                     {record}
                  </Typography>
               </Box>
            )}

            {/* Pronouns to the left of flag */}
            {data && data.CountryFlag && data.PREFERRED_PRONOUNS && (
               <Box
                  component={motion.div}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ easing: "easeInOut" }}
                  sx={{
                     position: "absolute",
                     zIndex: 200,
                     top: 652,
                     left: 170,
                     width: 170,
                  }}
               >
                  <Typography
                     variant='fmPlayerPronoun'
                     component='div'
                     sx={{ textTransform: "uppercase", fontSize: "1.3em" }}
                  >
                     {data.PREFERRED_PRONOUNS}
                  </Typography>
               </Box>
            )}

            {/* WinStreak to the right of flag, opposite pronouns */}
            {dataFields?.showWinStreak && winStreak && Array.isArray(winStreak) && winStreak.length > 0 && (
               <Box
                  component={motion.div}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ easing: "easeInOut" }}
                  sx={{
                     position: "absolute",
                     zIndex: 200,
                     top: 652,
                     left: 450,
                     display: "flex",
                     gap: "4px",
                     alignItems: "center",
                     justifyContent: "flex-end",
                     width: 190,
                     height: 31,
                  }}
               >
                  {[...winStreak].reverse().map((result, index) => {
                     // Handle both old format (string) and new format (object with result and roundName)
                     const resultValue = typeof result === 'object' && result !== null ? result.result : result;
                     const roundName = typeof result === 'object' && result !== null ? result.roundName : null;
                     
                     return result !== null && result !== undefined && resultValue ? (
                        <Box
                           key={`winstreak-${index}`}
                           title={roundName || undefined}
                           sx={{
                              width: "1.6em",
                              height: "1.6em",
                              borderRadius: "50%",
                              border: "2px solid rgb(211, 211, 211, 0.5)",
                              backgroundColor: resultValue === "W" ? "#4caf50" : resultValue === "L" ? "#f44336" : resultValue === "D" ? "#ff9800" : "#9e9e9e",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: roundName ? "help" : "default",
                           }}
                        >
                           <Typography
                              component='span'
                              sx={{
                                 fontSize: "1em",
                                 fontWeight: 700,
                                 color: "#ffffff",
                                 textAlign: "center",
                                 lineHeight: 1,
                              }}
                           >
                              {resultValue}
                           </Typography>
                        </Box>
                     ) : null;
                  })}
               </Box>
            )}
         </>
      </>
   );
}
